export const RULE = {
    FLOAT_NUMBER: /^([0-9０-９]+([.][0-9０-９]*)?|[.][0-9０-９]+)$/,
    NUMBER: /^[0-9０-９]*$/,
    EMAIL: /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/,
};
